export const notificationTemplates = [
  {
    id: 'NT001',
    name: 'Training Not Started',
    trigger: 'not_started',
    subject: 'Action Required: You have training waiting for you',
    body: `Hi {{firstName}},\n\nYou have been assigned "{{trainingName}}" which is due on {{dueDate}}.\n\nPlease log in to the CyberGuard platform and complete your training as soon as possible.\n\nIf you have any questions, contact your manager {{managerName}}.\n\nBest regards,\nCyberGuard Security Team`,
    channel: 'email',
    isActive: true,
    category: 'training',
    language: 'en',
  },
  {
    id: 'NT001-ES',
    name: 'Capacitación No Iniciada',
    trigger: 'not_started',
    subject: 'Acción Requerida: Tienes capacitación pendiente',
    body: `Hola {{firstName}},\n\nSe te ha asignado "{{trainingName}}" con fecha límite el {{dueDate}}.\n\nPor favor, inicia sesión en la plataforma CyberGuard y completa tu capacitación lo antes posible.\n\nSi tienes alguna pregunta, comunícate con tu gerente {{managerName}}.\n\nAtentamente,\nEquipo de Seguridad CyberGuard`,
    channel: 'email',
    isActive: true,
    category: 'training',
    language: 'es',
  },
  {
    id: 'NT002',
    name: 'Training Due Soon',
    trigger: 'due_soon',
    subject: 'Reminder: "{{trainingName}}" is due in {{daysLeft}} days',
    body: `Hi {{firstName}},\n\nThis is a friendly reminder that "{{trainingName}}" is due on {{dueDate}} — that's just {{daysLeft}} day(s) away.\n\nYour current progress: {{completionPct}}%. Please log in to complete your training before the deadline.\n\nBest regards,\nCyberGuard Security Team`,
    channel: 'email',
    isActive: true,
    category: 'training',
    language: 'en',
  },
  {
    id: 'NT002-ES',
    name: 'Capacitación Próxima a Vencer',
    trigger: 'due_soon',
    subject: 'Recordatorio: "{{trainingName}}" vence en {{daysLeft}} días',
    body: `Hola {{firstName}},\n\nEste es un recordatorio amistoso de que "{{trainingName}}" vence el {{dueDate}} — faltan solo {{daysLeft}} día(s).\n\nTu progreso actual: {{completionPct}}%. Por favor, inicia sesión y completa tu capacitación antes de la fecha límite.\n\nAtentamente,\nEquipo de Seguridad CyberGuard`,
    channel: 'email',
    isActive: true,
    category: 'training',
    language: 'es',
  },
  {
    id: 'NT003',
    name: 'Overdue Training',
    trigger: 'overdue',
    subject: 'URGENT: Overdue training — "{{trainingName}}"',
    body: `Hi {{firstName}},\n\n"{{trainingName}}" was due on {{dueDate}} and has not been completed.\n\nThis is now overdue by {{daysOverdue}} day(s). Please complete it immediately.\n\nYour manager {{managerName}} has been notified.\n\nBest regards,\nCyberGuard Security Team`,
    channel: 'email',
    isActive: true,
    category: 'training',
    language: 'en',
  },
  {
    id: 'NT003-ES',
    name: 'Capacitación Vencida',
    trigger: 'overdue',
    subject: 'URGENTE: Capacitación vencida — "{{trainingName}}"',
    body: `Hola {{firstName}},\n\n"{{trainingName}}" debía completarse el {{dueDate}} y no ha sido terminada.\n\nEstá vencida hace {{daysOverdue}} día(s). Por favor, complétala de inmediato.\n\nTu gerente {{managerName}} ha sido notificado.\n\nAtentamente,\nEquipo de Seguridad CyberGuard`,
    channel: 'email',
    isActive: true,
    category: 'training',
    language: 'es',
  },
  {
    id: 'NT004',
    name: 'Phishing Follow-Up',
    trigger: 'phishing_followup',
    subject: 'Important: Complete your phishing awareness training',
    body: `Hi {{firstName}},\n\nDuring our recent phishing simulation "{{simulationName}}", an action was recorded on your account.\n\nYou have been assigned a short remedial training module: "{{trainingName}}".\n\nPlease complete this within {{daysLeft}} days to reset your risk status.\n\nBest regards,\nCyberGuard Security Team`,
    channel: 'email',
    isActive: true,
    category: 'phishing',
    language: 'en',
  },
  {
    id: 'NT004-ES',
    name: 'Seguimiento de Phishing',
    trigger: 'phishing_followup',
    subject: 'Importante: Completa tu capacitación de concienciación sobre phishing',
    body: `Hola {{firstName}},\n\nDurante nuestra simulación de phishing reciente "{{simulationName}}", se registró una acción en tu cuenta.\n\nSe te ha asignado un módulo de capacitación remedial: "{{trainingName}}".\n\nPor favor, complétalo en {{daysLeft}} días para restablecer tu estado de riesgo.\n\nAtentamente,\nEquipo de Seguridad CyberGuard`,
    channel: 'email',
    isActive: true,
    category: 'phishing',
    language: 'es',
  },
  {
    id: 'NT005',
    name: 'Compliance Deadline',
    trigger: 'compliance_deadline',
    subject: 'Compliance Alert: "{{requirementName}}" due in {{daysLeft}} days',
    body: `Hi {{firstName}},\n\nThis is a compliance reminder. The following requirement is due soon:\n\n• Requirement: {{requirementName}}\n• Type: {{requirementType}}\n• Due Date: {{dueDate}}\n\nFailing to complete this by the deadline may result in a compliance violation.\n\nPlease log in to CyberGuard immediately.\n\nBest regards,\nCyberGuard Compliance Team`,
    channel: 'email',
    isActive: true,
    category: 'compliance',
    language: 'en',
  },
  {
    id: 'NT005-ES',
    name: 'Fecha Límite de Cumplimiento',
    trigger: 'compliance_deadline',
    subject: 'Alerta de Cumplimiento: "{{requirementName}}" vence en {{daysLeft}} días',
    body: `Hola {{firstName}},\n\nEste es un recordatorio de cumplimiento. El siguiente requisito vence pronto:\n\n• Requisito: {{requirementName}}\n• Tipo: {{requirementType}}\n• Fecha límite: {{dueDate}}\n\nNo completarlo antes de la fecha límite puede resultar en una violación de cumplimiento.\n\nPor favor, inicia sesión en CyberGuard de inmediato.\n\nAtentamente,\nEquipo de Cumplimiento CyberGuard`,
    channel: 'email',
    isActive: true,
    category: 'compliance',
    language: 'es',
  },
  {
    id: 'NT006',
    name: 'Manager Escalation',
    trigger: 'manager_escalation',
    subject: 'Team Compliance Alert: {{learnerName}} has overdue training',
    body: `Hi {{managerName}},\n\nThis is an automated escalation notice.\n\n{{learnerName}} ({{department}}) has the following overdue items:\n\n• Training: {{trainingName}}\n• Due Date: {{dueDate}}\n• Days Overdue: {{daysOverdue}}\n\nPlease follow up with your team member directly.\n\nBest regards,\nCyberGuard Security Team`,
    channel: 'email',
    isActive: true,
    category: 'escalation',
    language: 'en',
  },
  {
    id: 'NT006-ES',
    name: 'Escalación a Gerente',
    trigger: 'manager_escalation',
    subject: 'Alerta de Cumplimiento del Equipo: {{learnerName}} tiene capacitación vencida',
    body: `Hola {{managerName}},\n\nEste es un aviso de escalación automática.\n\n{{learnerName}} ({{department}}) tiene los siguientes elementos vencidos:\n\n• Capacitación: {{trainingName}}\n• Fecha límite: {{dueDate}}\n• Días vencida: {{daysOverdue}}\n\nPor favor, comunícate directamente con tu miembro del equipo.\n\nAtentamente,\nEquipo de Seguridad CyberGuard`,
    channel: 'email',
    isActive: true,
    category: 'escalation',
    language: 'es',
  },
];